<template>
  <div>
    <!-- <div class="row mb-3 ml-1 ">
      <div class="col stats-block d-flex justify-content-center align-items-center">
          <p><span class="total-header">Total:</span> <span class="tab user-stat">{{ total }} </span>  </p>
      </div>
    </div> -->

    <p class="ml-3"><span class="">Total: {{ total }} </span></p>

    <div class="row mb-3 ml-1" style="margin-top: 2px;">
      <div v-for="(item,index) in statArray" :key ="index"  class="col-lg-1 stats-block">
        <p class="stats-header">{{item[0]}} </p>
        <p class="user-stat">{{ item[1].length }} ({{item[1].length / total * 100 | singleDecimal}}%)</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['users','statuses'],
    data(){
        return {
            //statArray will be a multi dimensional array [[status1,[users in status1],], [status2,users in status2]...]
            statArray: [],
            total:0
        }
    },

    created(){
        //each element in statusArray is another array where the first element is the status name and second element is an array of users associated with that status
        for (var status in this.statuses){
            this.statArray.push([this.statuses[status],[]])
        };
        for (var user in this.users){
            for (var stat in this.statuses){
                if (this.users[user].status == this.statuses[stat]){
                    this.statArray[stat][1].push(this.users[user]);
                    break;
                }
            }
        }

        this.total = 0;

        for (var item in this.statArray){
            this.total+= this.statArray[item][1].length;
        }

        console.log("total is " + this.total)
        console.log(this.statArray)

    },

}

</script>

<style>
  .tab {
      display: inline;
      margin-left: 1vw;
  }
  .total-header{
    font-family: 'Lato';
    font-weight: 600;
    font-size: 1.25vw;
    height: 45px;
    overflow-wrap: break-word;
  }
  .stats-block {
    background-color: var(--bootstrapgrey);
    padding-top: 9px;
    padding-bottom: 9px;
    margin-right: 4px;
    border-radius: 3px;

    box-shadow: 0 .15rem 0.5rem rgba(0,0,0,.15)!important;
  }

  .stats-header {
    font-family: 'Lato';
    font-weight: 800;
    font-size: .80vw;
    height: 45px;
    overflow-wrap: break-word;
  }

  .user-stat {
    font-size: 1.25vw;
  }

  @media (max-width: 1717px) {
    .stats-header {
      height: 65px;
    }
  }
  @media (max-width: 1438px) {
    .user-stat {
      font-size: 16px;
    }
  }
  @media (max-width: 1319px) {
    .user-stat {
      font-size: 14px;
    }
  }
  @media (max-width: 1238px) {
    .stats-header {
      height: 80px;
    }
  }
  @media (max-width: 992px) {
    .stats-header {
      height: 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/agents/StatusStats.vue